export const AGENT_TEST_SCOPES = ['global', 'common', 'subProject'] as const;
export type AgentTestScope = (typeof AGENT_TEST_SCOPES)[number];

export const AGENT_TEST_INTERACTION_TYPES = ['single_turn', 'multi_turn'] as const;
export type AgentTestInteractionType = (typeof AGENT_TEST_INTERACTION_TYPES)[number];

export const AGENT_TEST_TURN_ROLES = ['user', 'assistant', 'tool'] as const;
export type AgentTestTurnRole = (typeof AGENT_TEST_TURN_ROLES)[number];

export interface AgentTestTurn {
  role: AgentTestTurnRole;
  content: string;
  source?: 'script' | 'simulator';
  toolCallId?: string;
  toolName?: string;
}

export interface AgentTestScenario {
  id: number;
  name: string;
  description: string | null;
  scope: AgentTestScope;
  projectId: number | null;
  subProjectId: number | null;
  interactionType: AgentTestInteractionType;
  turns: AgentTestTurn[];
  expectedBehavior: string;
  toolStubs: Record<string, unknown> | null;
  requiredTools: string[];
  tag: string;
  enabled: boolean;
  createdBy: number | null;
  updatedBy: number | null;
  createdAt: string;
  updatedAt: string;
  lastScore?: number | null;
  lastScoredAt?: string | null;
}

export interface ScenariosListParams {
  projectId: number;
  scope?: AgentTestScope;
  tag?: string;
  enabled?: boolean;
  page: number;
  limit: number;
}

export interface ScenariosListResponse {
  data: AgentTestScenario[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

export interface ScenarioBody {
  name: string;
  description: string;
  scope: AgentTestScope;
  projectId: number | null;
  subProjectId: number | null;
  interactionType: AgentTestInteractionType;
  turns: AgentTestTurn[];
  expectedBehavior: string;
  toolStubs: Record<string, unknown> | null;
  requiredTools: string[];
  tag: string;
  enabled: boolean;
}

export interface DuplicateScenarioBody {
  projectId: number;
  subProjectId?: number | null;
  name?: string;
}

export const SCOPE_LABELS: Record<AgentTestScope, string> = {
  global: 'Global',
  common: 'Inmobiliaria',
  subProject: 'Proyecto',
};

export const categoriesFromScenarios = (scenarios: Pick<AgentTestScenario, 'tag'>[]): string[] =>
  [...new Set(scenarios.map((scenario) => scenario.tag.trim()).filter((tag) => tag.length > 0))].sort((a, b) =>
    a.localeCompare(b, 'es')
  );
